export const GetTextColor = (bgColor) => {
    let color = bgColor.replace(/ /g, "");

    switch (color) {
        case "8b1c93":
        case "rgb(45,132,42)":
        case "rgb(131,15,26)":
        case "rgb(41,41,42)":
        case "rgb(30,52,102)":
        case "rgb(139,28,147)":
        case "rgb(6,79,145)":
        case "ce3781":
        case "5e0065":
        case "1e3466":
        case "001443":
        case "830f1a":
        case "29292a":
        case "515151":
        case "064f91":
        case "006269":
            return {textColor: "#fff", hoverColor: "#000"};
        default:
            return {textColor: "#000", hoverColor: "#fff"};
    }
};
export const GetButtonColor = (ButtonColor) => {
    const [theme] = useGlobal("theme");
    let color = ButtonColor == "" ? theme.colors.primary : `#${ButtonColor}`;
    const {textColor} = ButtonColor != "" && GetTextColor(ButtonColor);
    return {color, textColor};
};

